import { StatisticsListItem } from '../../components/StatisticsListItem';
import { CheckboxListItem } from '../../components/CheckboxListItem';
import { RadioListItem } from '../../components/RadioListItem';
import { EStatus } from '../../../../repositories/journal/v1/get-poll';
import { IPostPoll } from '../../../../types/postPoll';

interface IGetListItemType extends Pick<IPostPoll, 'isMultiAnswer' | 'dateEnd' | 'pollStatus'> {
  isUserVoted: boolean;
  now: Date;
}

/** Возвращает компонент элемента списка Опроса */
export const getListItemComponent = ({ pollStatus, dateEnd, isMultiAnswer, isUserVoted, now }: IGetListItemType) => {
  if (pollStatus !== EStatus.Active || (dateEnd && new Date(dateEnd) <= now) || isUserVoted) {
    return { component: StatisticsListItem, name: 'StatisticsListItem' };
  }

  if (isMultiAnswer) {
    return { component: CheckboxListItem, name: 'CheckboxListItem' };
  }

  return { component: RadioListItem, name: 'RadioListItem' };
};
